import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Image from '../../atoms/Image/Image';

const navList = [
  {
    name: 'BoB is',
    id: 0,
    innerNav: [
      { id: 0, name: 'Message', src: '/introduce/message' },
      { id: 1, name: 'History', src: '/introduce/history' },
      { id: 2, name: 'BoB Center Introduce', src: '/introduce/bci' },
      { id: 3, name: 'BI Introduce', src: '/introduce/bi' },
      { id: 4, name: 'Visit way', src: '/introduce/visit' },
    ],
  },
  {
    name: 'Education',
    id: 1,
    innerNav: [
      { id: 0, name: 'Education Process Plan', src: '/education/process' },
      { id: 1, name: 'Track Introduce', src: '/education/track' },
      { id: 2, name: 'Trainee Benefits', src: '/education/trainee' },
    ],
  },
  {
    name: 'Footprints',
    id: 2,
    innerNav: [
      { id: 0, name: 'Achievements', src: '/footprint/achievement' },
      { id: 1, name: 'Edu Sketch', src: '/footprint/edu' },
      { id: 2, name: 'Video', src: '/footprint/video' },
      { id: 3, name: 'MOU', src: '/footprint/mou' },
      { id: 4, name: 'Press Release', src: '/footprint/release' },
    ],
  },
  {
    name: 'Notice',
    id: 3,
    innerNav: [
      { id: 0, name: 'Notice', src: '/notice/list' },
      { id: 1, name: 'Brochure', src: '/notice/brochure' },
    ],
  },
];

export default function MHeader() {
  const { pathname } = useLocation();

  const useStyles = makeStyles((theme) => ({
    root: {
      display: 'none',
      position: 'fixed',
      top: 0,
      height: '64px',
      alignItems: 'center',
      zIndex: 10,
      width: '100vw',
      backgroundColor: pathname === '/' ? 'none' : 'white',
      '@media only screen and (max-width: 768px)': {
        display: 'flex',
      },
    },
    menu: {
      cursor: 'pointer',
      width: '32px',
      height: '32px',
      margin: 'auto 32px',
      position: 'fixed',
    },
    icon: {
      height: '48px',
      margin: '0 auto',
      cursor: 'pointer',
    },
    navList: {
      display: 'none',
      backgroundColor: 'white',
      width: '100vw',
      maxWidth: '560px',
      height: '100vh',
      position: 'fixed',
      left: 0,
      top: 0,
      overflow: 'scroll',
      zIndex: 12,
      paddingBottom: '56px',
      boxSizing: 'border-box',
      '&>div:nth-child(2n)': {
        backgroundColor: '#f4f6f9',
      },
    },
    closeBox: {
      height: '64px',
    },
    close: {
      width: '32px',
      height: '32px',
      margin: '16px 32px',
      cursor: 'pointer',
    },
    innerNav: {
      maxHeight: 0,
      overflow: 'hidden',
      transition: 'all .5s',
    },
    navTitle: {
      display: 'flex',
      alignItems: 'center',
      height: '56px',
      fontSize: '20px',
      lineHeight: '24px',
      padding: '0 32px',
      cursor: 'pointer',
    },
    navName: {
      cursor: 'pointer',
      fontSize: '16px',
      lineHeight: '20px',
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      padding: '0 32px',
      color: '#5a5a5a',
    },
    kor: {
      height: '56px',
      display: 'flex',
      position: 'fixed',
      alignItems: 'center',
      fontSize: '20px',
      padding: '0 32px',
      cursor: 'pointer',
      bottom: 0,
      width: '100%',
    },
  }));

  const classes = useStyles();

  const navigate = useNavigate();

  const handleHome = () => {
    navigate('/');
  };

  const openNav = () => {
    const nav = document.querySelector('#navList');

    nav.style.display = 'initial';

    for (const d of navList) {
      let flag = false;
      for (const i of d.innerNav) {
        if (i.src === pathname) {
          flag = true;
        }
      }
      if (flag) {
        document.querySelector(`#nav_${d.id}`).style.maxHeight = '600px';
      } else {
        document.querySelector(`#nav_${d.id}`).style.maxHeight = 0;
      }
    }
  };
  const closeNav = () => {
    const nav = document.querySelector('#navList');

    nav.style.display = 'none';
  };

  const handleClick = (n) => {
    navigate(n.src);
    document.querySelector('#navList').scrollTop = 0;
    closeNav();
    window.scrollTo(0, 0);
  };

  const handleInnerNav = (id) => {
    const nav = document.querySelector(`#${id}`);
    if (nav.style.maxHeight === '600px') {
      nav.style.maxHeight = 0;
    } else {
      nav.style.maxHeight = '600px';
    }
  };

  const handleKor = () => {
    window.location.href = 'https://www.kitribob.kr/';
  };

  return (
    <Box className={classes.root} onMouseLeave={closeNav}>
      <Image
        onClick={openNav}
        className={classes.menu}
        src={pathname === '/' ? '../../images/icon/outline_menu_white_48@2x.png' : '../../images/icon/outline_menu_black_48@2x.png'}
        alt='Menu Icon'
      />
      <Image onClick={handleHome} className={classes.icon} src={pathname === '/' ? '../../images/logo_wh@2x.png' : '../../images/logo_bl@2x.png'} alt='header icon' />
      <Box id='navList' className={classes.navList}>
        <Box className={classes.closeBox}>
          <Image onClick={closeNav} src={'../../images/icon/outline_close_black_48@2x.png'} alt='Close Icon' className={classes.close} />
        </Box>
        {navList.map((n, i) => {
          return (
            <Box key={i}>
              <Box onClick={handleInnerNav.bind(this, `nav_${n.id}`)} className={classes.navTitle}>
                {n.name}
              </Box>
              <Box className={classes.innerNav} id={`nav_${n.id}`}>
                {n.innerNav.map((d, j) => {
                  return (
                    <Box onClick={handleClick.bind(this, d)} key={j} className={classes.navName} style={pathname === d.src ? { fontWeight: '600' } : {}}>
                      - {d.name}
                    </Box>
                  );
                })}
              </Box>
            </Box>
          );
        })}
        <Box className={classes.kor} onClick={handleKor}>
          KOR
        </Box>
      </Box>
    </Box>
  );
}
